import axios from "axios";
import { APIURL } from "./../Constantes";
// import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlLogin = "Login";

export const login = async ({payload}) =>{
    return await axios.post(`${APIURL}/${urlLogin}`, payload)
    .then((Response) =>{
        return Response.data;
    })
    .catch((Error) =>{
        return getError(Error);
    })
}

export const logOut = async ()  => {
    return await axios.delete(`${APIURL}/${urlLogin}/LogOut`)
    .then((Response) =>{
        return Response.data;
    })
    .catch((Error) =>{
        return getError(Error);
    })
}